import { motion } from "framer-motion";

const images = [
  {
    src: "https://images.unsplash.com/photo-1615233500064-caa995e2f9dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    alt: "Golden Retriever puppy portrait",
    span: "md:col-span-5 md:row-span-2 aspect-[3/4]",
  },
  {
    src: "https://images.unsplash.com/photo-1774056110292-ad40b8d36cdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    alt: "Golden Retriever running in field",
    span: "md:col-span-4 aspect-square",
  },
  {
    src: "https://images.unsplash.com/photo-1592769606534-fe78d27bf450?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    alt: "Golden Retriever puppy sitting",
    span: "md:col-span-3 aspect-square",
  },
  {
    src: "https://images.pexels.com/photos/4725941/pexels-photo-4725941.jpeg?auto=compress&cs=tinysrgb&w=700",
    alt: "Golden Retriever at sunset",
    span: "md:col-span-4 aspect-[4/3]",
  },
  {
    src: "https://images.unsplash.com/photo-1611250282006-4484dd3fba6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    alt: "Golden Retriever puppy with collar",
    span: "md:col-span-3 aspect-[4/3]",
  },
];

export const GoldenShowcase = () => {
  return (
    <section id="puppies" className="py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-4"
      >
        <div>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-[#D97736] mb-4">
            Recently Working On
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0F2520]">
            Authentic Golden Retrievers
          </h2>
        </div>
        <p className="text-base font-light text-[#0F2520]/70 max-w-sm">
          Raised in a healthy, loving environment — well-fed, vaccinated, and ready for their forever home.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-6">
        {images.map((img, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className={`col-span-2 ${img.span} relative rounded-[2rem] overflow-hidden group`}
          >
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F2520]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </motion.div>
        ))}
      </div>
    </section>
  );
};
